import { render } from "./abstractComponent.vue?vue&type=template&id=26e6fda2&scoped=true"
import script from "./abstractComponent.vue?vue&type=script&lang=js"
export * from "./abstractComponent.vue?vue&type=script&lang=js"

import "./abstractComponent.vue?vue&type=style&index=0&id=26e6fda2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e6fda2"]])

export default __exports__